<template>
    <iMineTemplate :pageTitle="pageTitle" :activedParentKey="activedParentKey" :activedKey="activedKey">
        <template #rightContent>
            <div class="feedback-box pl20 pr20 bgfff">
                <van-cell title="乱价投诉" title-class="f18 c222 text-left" class="pt20 pl0 pb20 pr0 border-b" center :border="false"
                          value-class="cpointer">
<!--                    <template>-->
<!--                        <router-link :to="{name:LinkTypeCode.FeedbackHistory}">-->
<!--                            <span class="c0F6EE9 f12">乱价投诉</span>-->
<!--                        </router-link>-->
<!--                    </template>-->
                </van-cell>
                <van-form @submit="()=>{IsDetail||onSubmit()}" class="pl152 pt60 pb110" v-if="!Success||IsDetail">
<!--                    <van-row type="flex" align="center" class="mb20">-->
<!--                        <van-col style="width:94px" class="text-left c222 f16">反馈类型</van-col>-->
<!--                        <van-col :span="18">-->
<!--                            <div class="select-box" :class="{'ac':selectContent}">-->
<!--                                <div class="title" @click.stop="()=>{IsDetail||handleTypeSelect()}">{{(selectedTypeList&&selectedTypeList.text) || '请选择'}}-->
<!--                                </div>-->
<!--                                <ul v-if="selectContent">-->
<!--                                    <li v-for="(item,i) in typeOption" :key="i" class="c222 f14" @click.stop="handleType(item)"-->
<!--                                        :class="{'act':item.text == selectedTypeList&&selectedTypeList.text}">{{item.text}}</li>-->
<!--                                </ul>-->
<!--                            </div>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
                    <van-row type="flex" class="mb20">
                        <van-col style="width:94px" class="text-left c222 f16 pt15">反馈内容</van-col>
                        <van-col :span="18">
                            <van-field :disabled="IsDetail" v-model="message" rows="7" autosize label type="textarea" maxlength="500"
                                       :placeholder="IsDetail?'':'请输入反馈内容'" show-word-limit class="f16 c222 content-bo pt15 pl15 pr15 pb15"
                                       :class="{'content-bo-ac pb11i':focusBo}" @focus="focusBo = true" @blur="focusBo = false" />
                        </van-col>
                    </van-row>
                    <van-row type="flex">
                        <van-col style="width:94px" class="text-left c222 f16 pt15">相关图片</van-col>
                        <van-col :span="18">
                            <van-grid :border="false" :column-num="4">
                                <van-grid-item v-for="(item,index) in conUploader" :key="index">
                                    <iFile class="i_radius fx justify-content-center" :bg="_getPic(item.ImageUrl,true)" readonly
                                           :addText="IsDetail?' ':'添加照片'">
                                        <van-icon v-if="!IsDetail" name="clear" size="20px" style="position: absolute;top: -10px;right: -10px;"
                                                  class="c999 cpointer" @click.stop="delImage(index)" />
                                    </iFile>
                                </van-grid-item>
                                <van-grid-item v-if="!IsDetail">
                                    <iFile class="i_radius hidden fx justify-content-center cpointer" @change="onFile">
                                        <van-icon :name="require('../../assets/mine/xiangji.png')" size="36px" color="#999" />
                                    </iFile>
                                </van-grid-item>
                            </van-grid>
                        </van-col>
                    </van-row>
                    <van-button v-if="!IsDetail" color="#0F6EEA" text="提交" class="submitBtn f16 cfff fw600 mt120" :loading="btn" :disabled="(!message)&&
            (!conUploader.length)||btn" />
                </van-form>
                <div v-else>
                    <van-icon size="87px" :name="require('@/assets/mine/fankui-success-icon.png')" class="mt108" />
                    <div class="f26 c0F6EEA fw600 mb10 mt30">投诉提交成功</div>
                    <div class="c777 f14 pb20">感谢您对药约約的支持，我们会尽快处理！</div>
                    <van-button color="#0F6EEA" text="返回首页" class="submitBtn f16 cfff fw600 mt60" @click.stop="$router.push(LinkTypeCode.Home)" />
                </div>
            </div>
        </template>
    </iMineTemplate>
</template>
<script>
    import { LinkTypeCode } from "@/dictionary/base.js";
    import { BaseMixin } from "../../mixins/BaseMixin.js";
    import iFile from "@/components/uploader.vue";
    export default {
        name: "DisorderlyPrice",
        mixins: [BaseMixin],
        components: { iFile },
        data() {
            return {
                LinkTypeCode,
                pageTitle: ["帮助中心", "问题反馈"],
                activedParentKey: 4,
                activedKey: 43,
                typeOption: [
                    { text: "商品相关", value: 1, id: 2 },
                    { text: "物流状况", value: 2, id: 1 },
                    { text: "客户服务", value: 3 },
                    { text: "优惠活动", value: 4 },
                    { text: "功能异常", value: 5 },
                    { text: "产品建议", value: 6 },
                    { text: "其他", value: 7, id: 3 }
                ],
                selectContent: false,
                selectedTypeList: null,
                focusBo: false,
                message: "",
                uploader: [],
                conUploader: [],
                SignImage: "",
                btn: false,
                Success: false,
                IsDetail: false,
                Id: ''
            };
        },
        mounted() {
            this.Id = this.$route.query.Id || '';
            if (this.Id != '') {
                this.IsDetail = true;
                this.Success = false;
                this.loadData();
            }
        },
        methods: {
            loadData() {
                const _this = this;
                _this.$hys.openLoading();
                _this.getAction('/api_customer/CustomerFeedback/Detail', { id: _this.Id }).then(res => {
                    if (!res.IsSuccess) {
                        _this.$toast({ position: "bottom", message: res.Msg });
                        _this.$router.back(-1);
                        return;
                    }
                    if (res.Data.CustomerFeedbackImages && res.Data.CustomerFeedbackImages.length) {
                        res.Data.CustomerFeedbackImages.map(w => {
                            _this.conUploader.push(w);
                        });
                    }
                    _this.selectedTypeList = { text: res.Data.FeedbackTypeName };
                    _this.message = res.Data.FeedbackContent;
                })
            },
            delImage(index) {
                this.conUploader.splice(index, 1);
            },
            onFile(file) {
                this.SignImage = file;
                let img = {
                    ImageUrl: this.SignImage
                };
                this.conUploader.push(img);
            },
            // 点击反馈类型
            handleTypeSelect() {
                this.selectContent = true;
            },
            handleType(item) {
                this.selectedTypeList = item;
                this.selectContent = false;
            },
            async onSubmit() {
                this.btn = true;
                let params = {
                    FeedbackType: '',
                    FeedbackContent: this.message,
                    CreateCustomerFeedbackImageDtos: this.conUploader
                };
                this.$hys.openLoading();
                const res = await this.postAction("/api_customer/CustomerFeedback/CreateMessPirce", params);
                this.$hys.clearLoading();
                if (res.IsSuccess) {
                    this.Success = true;
                    this.selectedTypeList = null;
                    this.conUploader = [];
                    this.message = "";
                    this.btn = false;
                } else {
                    this.$toast({ position: "bottom", message: res.Msg });
                    this.btn = false;
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    .feedback-box {
        border-radius: 2px;
        border: 1px solid rgba(232, 232, 232, 1);
        width: 100%;
        min-height: 880px;

        .pl152 {
            padding-left: 152px;
        }

        .pt60 {
            padding-top: 60px;
        }

        .pb110 {
            padding-bottom: 110px;
        }

        .select-box {
            width: 460px;
            height: 60px;
            border-radius: 2px;
            border: 1px solid rgba(229, 229, 229, 1);
            position: relative;

            .title {
                color: #222;
                font-size: 16px;
                padding: 0 15px;
                text-align: left;
                line-height: 60px;
                cursor: pointer;
                position: relative;

                &::after {
                    position: absolute;
                    top: 50%;
                    margin-top: -5px;
                    border: 3px solid;
                    border-color: transparent transparent #777777 #777777;
                    right: 15px;
                    -webkit-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                    opacity: 0.8;
                    content: "";
                }
            }

            >ul {
                position: absolute;
                margin-top: 10px;
                right: 0;
                left: 0;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 1px 16px 0px rgba(226, 226, 226, 1);
                padding: 0 20px;
                z-index: 1;

                >li {
                    padding: 15px 0;
                    border-bottom: 1px solid #e8e8e8;
                    text-align: left;
                    cursor: pointer;

                    &:last-child {
                        border-bottom: 0;
                    }

                    &:hover {
                        color: rgba(15, 110, 234, 1);
                    }
                }

                .act {
                    color: rgba(15, 110, 234, 1);
                }
            }
        }

        .ac {
            border-radius: 2px;
            border: 3px solid rgba(15, 110, 233, 1);
            height: 56px;

            .title {
                line-height: 56px;
            }
        }

        .content-bo {
            width: 460px;
            border-radius: 2px;
            border: 1px solid rgba(229, 229, 229, 1);
        }

        .content-bo-ac {
            border-radius: 2px;
            border: 3px solid rgba(15, 110, 233, 1);
        }

        .iFile {
            width: 100px;
            height: 100px;
            border-radius: 2px;
            border: 1px solid rgba(229, 229, 229, 1) !important;
        }

        /deep/.van-grid-item__content {
            padding: 0;
            align-items: flex-start;
        }

        /deep/.van-grid {
            width: 460px;
        }

        .submitBtn {
            width: 164px;
            height: 50px;
        }
    }

    .pb11i {
        padding-bottom: 11px !important;
    }

    .mt108 {
        margin-top: 108px;
    }
</style>
